<template>
  <qz-results-details
    :quote="quote"
    :is-view-monthly="isViewMonthly"
    :is-buy-online-disabled="isBuyOnlineDisabled"
    :details-description="detailsDescription"
    :selected-optional-extras="selectedOptionalExtras"
    :is-details-drawer-open="isDetailsDrawerOpen"
    :product-name="productName"
    :selected-premium="selectedPremium"
    :filter-extras="filterExtras"
    :quote-position-number="quotePositionNumber"
    @go-to-form="$emit('go-to-form')"
    @close-drawer="$emit('close-drawer')"
    @open-drawer-details="$emit('open-drawer-details', $event)"
  >
    <template
      v-if="hasBuyOnline"
      #how-to-buy
    >
      <div class="mb-4">
        <v-checkbox
          v-model="buyOnlineChecked"
          class="buy-online-checkbox mb-2"
          hide-details
        >
          <span
            slot="label"
            v-html="quoteDetails.buyOnlineCheckboxText"
          />
        </v-checkbox>
      </div>
    </template>

    <template #policy-excess>
      <h4 class="mb-3">
        Excess
      </h4>
      <p class="fs-10">This is the first portion of any loss that you are prepared to pay. This may vary depending on the insurance provider and the type of claim in relation to your bicycle policy.</p>
      <v-simple-table
        dense
        class="theme--light light"
      >
        <template #default>
          <tbody>
            <tr>
              <th>Compulsory excess</th>
              <td class="text-right">
                &pound;{{ quoteDetails.optionalExtra.excess.compulsory.value }}
              </td>
            </tr>
            <tr>
              <th>Can be varied</th>
              <td class="text-right">
                {{ quoteDetails.optionalExtra.excess.varied === 'Y' ? 'Yes' : 'No' }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </qz-results-details>
</template>

<script>
import QzResultsDetails from '@/components/QzResults/QzResultsDetails';
import { isEmpty } from 'lodash';

export default {
  name: 'results-details',
  components: {
    QzResultsDetails,
  },
  props: {
    quote: {
      required: false,
      type: Object,
      default: undefined,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
    isDetailsDrawerOpen: {
      type: Boolean,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    selectedPremium: {
      type: Object,
      default: undefined,
    },
    quotePositionNumber: {
      required: true,
      type: Number,
    },
  },
  data () {
    return {
      buyOnlineChecked: false,
    };
  },
  computed: {
    quoteDetails () {
      if (this.selectedPremium) {
        return Object.keys(this.selectedPremium.details).length && this.selectedPremium.details[0];
      }
      return this.quote?.details?.[0] || null;
    },
    hasBuyOnline () {
      return this.quoteDetails?.isBuyOnlineCheckbox;
    },
    isBuyOnlineDisabled () {
      return (!this.buyOnlineChecked && this.hasBuyOnline);
    },
  },
  methods: {
    filterExtras (condition) {
      let accumulator = {};
      Object.keys(this.quoteDetails.optionalExtra).forEach((cover) => {
        if (this.quoteDetails.optionalExtra[cover].included === condition && this.quoteDetails.optionalExtra[cover].description !== 'DO_NOT_SHOW') {
          accumulator[cover] = this.quoteDetails.optionalExtra[cover];
        }
      });

      switch (condition) {
        case 'Y':
          accumulator = { ...accumulator, otherCovered: this.quoteDetails.moreDetails.otherIncluded };
          break;
        case 'extra':
          accumulator = { ...accumulator, otherAvailable: this.quoteDetails.moreDetails.otherOptionalExtras };
          break;
      }

      return isEmpty(accumulator) ? null : accumulator;
    },
  },
};
</script>
